import React from 'react';

import { Heading } from '@depop/web-thrift-ui/Typography';
import { useParams } from 'next/navigation';

import { BubbleNavigation, type BubbleItem } from '../../BubbleNavigation';

import styles from './styles.module.css';

import { PageDescription } from '@/components/PageDescription';
import { ActivityTrackerEventType } from '@/modules/activityTracker/constants';
import { useActivityTracker } from '@/modules/activityTracker/useActivityTracker';
import { type CMSExplorePageBubbleNavItem } from '@/modules/cms/types';
import { transformBubbleNavItems } from '@/modules/explore/helpers';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

type Props = {
  title?: string;
  description?: string;
  items?: CMSExplorePageBubbleNavItem[];
};

export function PageHeaderBubbleNavigation({
  title,
  description,
  items = [],
}: Props) {
  const [, currentUser] = useCurrentUser();
  const { sendActivityTrackerEvent } = useActivityTracker({
    userId: currentUser?.id,
  });

  const { slug } = useParams<{ slug: string }>();
  const moduleName = `explore_${slug}_bubbles`;

  function handleBubbleClick(item: BubbleItem, index: number) {
    sendActivityTrackerEvent(ActivityTrackerEventType.MODULE_CLICK_ACTION, {
      moduleName,
      itemClicked: item.label,
      itemPosition: index,
      schemaVersion: '3.0',
    });
  }

  return (
    <div className={styles.container}>
      <Heading variant="lg">{title}</Heading>
      {description && <PageDescription text={description} />}
      {items.length > 0 && (
        <div className={styles.bubbleNavigationWrapper}>
          <BubbleNavigation
            items={transformBubbleNavItems(items, moduleName)}
            onBubbleClick={handleBubbleClick}
          />
        </div>
      )}
    </div>
  );
}
